import { RequestTypeInterface } from '../interfaces/requestType';

export class RequestType implements RequestTypeInterface {
    IDRequestType?: number;
    RequestType: string;
    Active: boolean;

    constructor() {
        this.RequestType = '';
        this.Active = true;
    }
}
